import { DownloadProgress } from 'src/components/download-progress';

export default DownloadProgress;
